module.exports = __webpack_public_path__ + "img/4.95e1892b.png";